export default __webpack_public_path__ + "static/media/locationPin.1480a1b7.svg";